const counterIncrementor = counter => counter + 1;

export default counterIncrementor;